import { Table } from "@renderbus/ui";
import styled from "styled-components";
import {
  ITransferRecordProps,
  useTransferRecord,
} from "../hooks/useTransferRecord";
import { useTabStore } from "../store/tab-store";
import { CouponType } from "../constant";

const TransferOperateContainer = styled.div`
  padding: 14px 16px;
  .coupon-no {
    padding-bottom: 14px;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #e0e1e1;
  }
  .transfer-operate .ant-table-cell {
    font-size: 12px;
    height: 36px;
  }
`;

export function TransferOperateDrawer({
  couponNo,
  transferData,
}: {
  couponNo: number;
  transferData: ITransferRecordProps[];
}) {
  const { transferColumns, freeCouponTransferColumns } = useTransferRecord();
  const { currentTab } = useTabStore();
  return (
    <TransferOperateContainer>
      <div className="coupon-no">{`NO.${couponNo}`}</div>
      <Table
        columns={
          currentTab === CouponType.RenderingMember
            ? freeCouponTransferColumns
            : transferColumns
        }
        dataSource={transferData}
        showPagination={false}
        className="transfer-operate"
      />
    </TransferOperateContainer>
  );
}
